import { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Link } from 'react-router-dom';

// Define use case categories and data
const useCases = [
{
  id: 1,
  title: "Customer Service AI Chatbot",
  description: "Automate customer inquiries and support on your website, 24/7.",
  category: "chatbot",
  icon: "💬"
},
{
  id: 2,
  title: "AI Voice Receptionist",
  description: "Handle incoming calls, route callers, and answer FAQs automatically.",
  category: "voice",
  icon: "📞"
},
{
  id: 3,
  title: "Social Media Content Generator",
  description: "Create engaging posts for multiple platforms from a single input.",
  category: "content",
  icon: "📱"
},
{
  id: 4,
  title: "Email Response Automation",
  description: "Auto-reply to common inquiries and categorize incoming emails.",
  category: "workflow",
  icon: "✉️"
},
{
  id: 5,
  title: "WhatsApp Business Assistant",
  description: "Engage with customers on WhatsApp with intelligent responses.",
  category: "chatbot",
  icon: "📱"
},
{
  id: 6,
  title: "Lead Qualification Calls",
  description: "Qualify leads through automated voice calls and gather information.",
  category: "voice",
  icon: "🎯"
},
{
  id: 7,
  title: "Product Recommendation Engine",
  description: "Suggest relevant products based on customer preferences and behavior.",
  category: "workflow",
  icon: "🛒"
},
{
  id: 8,
  title: "Blog Post Generator",
  description: "Create SEO-optimized blog content from simple topic inputs.",
  category: "content",
  icon: "📝"
}];


export default function UseCaseSection() {
  const [category, setCategory] = useState("all");

  const filteredUseCases = category === "all" ?
  useCases.slice(0, 8) :
  useCases.filter((useCase) => useCase.category === category).slice(0, 8);

  return (
    <section className="py-16 bg-white" data-id="df89lb52s" data-path="src/components/home/UseCaseSection.tsx">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="ufbtjunod" data-path="src/components/home/UseCaseSection.tsx">
        <div className="text-center mb-12" data-id="899soga7p" data-path="src/components/home/UseCaseSection.tsx">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="rvniaok2r" data-path="src/components/home/UseCaseSection.tsx">
            Browse Our Automation Use Cases
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="svinqczsv" data-path="src/components/home/UseCaseSection.tsx">
            Discover over 50 ways to automate your business processes with AI technology,
            from customer service to content creation.
          </p>
        </div>

        <Tabs defaultValue="all" className="w-full mb-8" data-id="foq3cpc6a" data-path="src/components/home/UseCaseSection.tsx">
          <TabsList className="w-full max-w-2xl mx-auto grid grid-cols-2 sm:grid-cols-5 bg-gray-100 p-1 rounded-lg" data-id="v0juzs8wj" data-path="src/components/home/UseCaseSection.tsx">
            <TabsTrigger
              value="all"
              onClick={() => setCategory("all")}
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-blue-600 data-[state=active]:to-purple-600 data-[state=active]:text-white text-gray-700 font-medium rounded-md transition-all duration-200" data-id="s0n11qc5i" data-path="src/components/home/UseCaseSection.tsx">

              All
            </TabsTrigger>
            <TabsTrigger
              value="chatbot"
              onClick={() => setCategory("chatbot")}
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-blue-600 data-[state=active]:to-purple-600 data-[state=active]:text-white text-gray-700 font-medium rounded-md transition-all duration-200" data-id="ut1lo7cif" data-path="src/components/home/UseCaseSection.tsx">

              Chatbots
            </TabsTrigger>
            <TabsTrigger
              value="voice"
              onClick={() => setCategory("voice")}
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-blue-600 data-[state=active]:to-purple-600 data-[state=active]:text-white text-gray-700 font-medium rounded-md transition-all duration-200" data-id="yybep27ml" data-path="src/components/home/UseCaseSection.tsx">

              Voice AI
            </TabsTrigger>
            <TabsTrigger
              value="content"
              onClick={() => setCategory("content")}
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-blue-600 data-[state=active]:to-purple-600 data-[state=active]:text-white text-gray-700 font-medium rounded-md transition-all duration-200" data-id="mgtc7qlku" data-path="src/components/home/UseCaseSection.tsx">

              Content
            </TabsTrigger>
            <TabsTrigger
              value="workflow"
              onClick={() => setCategory("workflow")}
              className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-blue-600 data-[state=active]:to-purple-600 data-[state=active]:text-white text-gray-700 font-medium rounded-md transition-all duration-200" data-id="jtcewf0x1" data-path="src/components/home/UseCaseSection.tsx">

              Workflow
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="all" className="mt-8" data-id="as1ihis1k" data-path="src/components/home/UseCaseSection.tsx">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="t15b4s76a" data-path="src/components/home/UseCaseSection.tsx">
              {filteredUseCases.map((useCase) =>
              <Card key={useCase.id} className="overflow-hidden hover:shadow-lg transition-shadow" data-id="zyp3skvx5" data-path="src/components/home/UseCaseSection.tsx">
                  <CardContent className="p-6" data-id="w4wr963u3" data-path="src/components/home/UseCaseSection.tsx">
                    <div className="text-4xl mb-4" data-id="l92sufnn3" data-path="src/components/home/UseCaseSection.tsx">{useCase.icon}</div>
                    <h3 className="text-xl font-medium text-gray-900 mb-2" data-id="hh71ix4d6" data-path="src/components/home/UseCaseSection.tsx">{useCase.title}</h3>
                    <p className="text-gray-600 mb-4" data-id="s7qydk9yj" data-path="src/components/home/UseCaseSection.tsx">{useCase.description}</p>
                  </CardContent>
                </Card>
              )}
            </div>
          </TabsContent>
          
          <TabsContent value="chatbot" className="mt-8" data-id="hfp8afq50" data-path="src/components/home/UseCaseSection.tsx">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="h784wavw8" data-path="src/components/home/UseCaseSection.tsx">
              {filteredUseCases.map((useCase) =>
              <Card key={useCase.id} className="overflow-hidden hover:shadow-lg transition-shadow" data-id="inxdvnkbv" data-path="src/components/home/UseCaseSection.tsx">
                  <CardContent className="p-6" data-id="wcet2m0zm" data-path="src/components/home/UseCaseSection.tsx">
                    <div className="text-4xl mb-4" data-id="z3mnlqv8h" data-path="src/components/home/UseCaseSection.tsx">{useCase.icon}</div>
                    <h3 className="text-xl font-medium text-gray-900 mb-2" data-id="xj2p05z9l" data-path="src/components/home/UseCaseSection.tsx">{useCase.title}</h3>
                    <p className="text-gray-600 mb-4" data-id="yy87z3x53" data-path="src/components/home/UseCaseSection.tsx">{useCase.description}</p>
                  </CardContent>
                </Card>
              )}
            </div>
          </TabsContent>
          
          <TabsContent value="voice" className="mt-8" data-id="7tmx3okh9" data-path="src/components/home/UseCaseSection.tsx">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="vx7mo4lur" data-path="src/components/home/UseCaseSection.tsx">
              {filteredUseCases.map((useCase) =>
              <Card key={useCase.id} className="overflow-hidden hover:shadow-lg transition-shadow" data-id="tyfjdiiy2" data-path="src/components/home/UseCaseSection.tsx">
                  <CardContent className="p-6" data-id="b67zu1b54" data-path="src/components/home/UseCaseSection.tsx">
                    <div className="text-4xl mb-4" data-id="zoqq84b5d" data-path="src/components/home/UseCaseSection.tsx">{useCase.icon}</div>
                    <h3 className="text-xl font-medium text-gray-900 mb-2" data-id="zy2qg4fu1" data-path="src/components/home/UseCaseSection.tsx">{useCase.title}</h3>
                    <p className="text-gray-600 mb-4" data-id="cf0evo5lv" data-path="src/components/home/UseCaseSection.tsx">{useCase.description}</p>
                  </CardContent>
                </Card>
              )}
            </div>
          </TabsContent>
          
          <TabsContent value="content" className="mt-8" data-id="lklr8erod" data-path="src/components/home/UseCaseSection.tsx">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="ignasa3av" data-path="src/components/home/UseCaseSection.tsx">
              {filteredUseCases.map((useCase) =>
              <Card key={useCase.id} className="overflow-hidden hover:shadow-lg transition-shadow" data-id="loacv9w4u" data-path="src/components/home/UseCaseSection.tsx">
                  <CardContent className="p-6" data-id="gkrddwnok" data-path="src/components/home/UseCaseSection.tsx">
                    <div className="text-4xl mb-4" data-id="b6j3prik5" data-path="src/components/home/UseCaseSection.tsx">{useCase.icon}</div>
                    <h3 className="text-xl font-medium text-gray-900 mb-2" data-id="c3aprvbe0" data-path="src/components/home/UseCaseSection.tsx">{useCase.title}</h3>
                    <p className="text-gray-600 mb-4" data-id="0wstrmwmt" data-path="src/components/home/UseCaseSection.tsx">{useCase.description}</p>
                  </CardContent>
                </Card>
              )}
            </div>
          </TabsContent>
          
          <TabsContent value="workflow" className="mt-8" data-id="nx6v0s77u" data-path="src/components/home/UseCaseSection.tsx">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="nf6bi2syw" data-path="src/components/home/UseCaseSection.tsx">
              {filteredUseCases.map((useCase) =>
              <Card key={useCase.id} className="overflow-hidden hover:shadow-lg transition-shadow" data-id="dccbe6sk4" data-path="src/components/home/UseCaseSection.tsx">
                  <CardContent className="p-6" data-id="lnj4c7din" data-path="src/components/home/UseCaseSection.tsx">
                    <div className="text-4xl mb-4" data-id="25hgf27o3" data-path="src/components/home/UseCaseSection.tsx">{useCase.icon}</div>
                    <h3 className="text-xl font-medium text-gray-900 mb-2" data-id="7fvmoxnso" data-path="src/components/home/UseCaseSection.tsx">{useCase.title}</h3>
                    <p className="text-gray-600 mb-4" data-id="n2egqvmh2" data-path="src/components/home/UseCaseSection.tsx">{useCase.description}</p>
                  </CardContent>
                </Card>
              )}
            </div>
          </TabsContent>
        </Tabs>

        <div className="text-center mt-12" data-id="ff5c2nlgn" data-path="src/components/home/UseCaseSection.tsx">
          <Button asChild size="lg" className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700" data-id="rqoc7bgax" data-path="src/components/home/UseCaseSection.tsx">
            <Link to="/use-cases" data-id="d3f3a1jqq" data-path="src/components/home/UseCaseSection.tsx">Discover More Use Cases</Link>
          </Button>
        </div>
      </div>
    </section>);

}